import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    updateProduct: {},
    isLoading: false,
   error : null
}

const updateProductSlice = createSlice({
    name: 'updateProduct',
    initialState,
    reducers:{
        updateProductPending: (state) => {
            state.isLoadingProducts = true;
        },
        updateProductSuccess: (state, {payload}) => {
            state.isLoading = false;
            state.updateProduct = payload;
            state.error = null;
        },
        updateProductFail: (state, {payload}) => {
            state.isLoading = false;
            state.error = payload;
        }
    }
})

export const {updateProductPending, updateProductSuccess, updateProductFail} = updateProductSlice.actions

export default updateProductSlice.reducer